import React from "react";
import ReactECharts from "echarts-for-react";

interface TimeChartProps {
    timeInSeconds: number;
}

const TimeChart: React.FC<TimeChartProps> = ({ timeInSeconds }) => {
    const options = {
        xAxis: {
            type: "value",
            min: 0,
            max: Math.ceil(timeInSeconds) + 1,
            axisLabel: {
                color: "#999",
                fontSize: 12,
                formatter: (value: number) => `${value.toFixed(1)}s`,
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: "#ddd",
                    type: "solid",
                },
            },
        },
        yAxis: {
            type: "category",
            data: ["LLM"],
            axisLabel: {
                show: false,
            },
            axisLine: {
                show: false,
            },
            axisTick: {
                show: false,
            },
        },
        series: [
            {
                name: "LLM",
                type: "bar",
                data: [timeInSeconds],
                barWidth: 30,
                itemStyle: {
                    color: "#00330F",
                    borderRadius: [10, 10, 10, 10],
                    borderColor: "#FFFFFF",
                    borderWidth: 3,
                    shadowBlur: 10,
                    shadowColor: "rgba(0, 0, 0, 0.2)",
                },
                label: {
                    show: false,
                },
            },
        ],
        grid: {
            left: "5%",
            right: "5%",
            top: "20%",
            bottom: "15%",
        },
        tooltip: {
            trigger: "axis",
            formatter: `{b}: {c}s`,
        },
        legend: {
            data: ["LLM"],
            left: "50px",
            bottom: "1px",
            padding: [20, 0, 0, 0],
            icon: 'circle',
            textStyle: {
                color: "#333",
                fontSize: 12,
            },
            itemStyle: {
                color: "#00330F",
            },
        },
    };

    return <ReactECharts option={options} style={{ height: 300, width: "100%" }} />;
};

export default TimeChart;
